export function hasNodeLogicPath(logicPaths = [], refId) {
  if (logicPaths.length === 0) {
    return false;
  }

  return logicPaths.some((path) => path[0] === refId);
}
